var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoNotificationText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6191 6.81451C14.6191 5.12179 15.9914 3.74951 17.6841 3.74951C19.3769 3.74951 20.7491 5.12179 20.7491 6.81451C20.7491 8.50724 19.3769 9.87951 17.6841 9.87951C15.9914 9.87951 14.6191 8.50724 14.6191 6.81451Z",
    fill: "currentColor "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.1191 6.81451C13.1191 6.03442 13.3148 5.30001 13.6598 4.65771H5.5918C4.34916 4.65771 3.3418 5.66507 3.3418 6.90772V18.9077C3.3418 20.1504 4.34916 21.1577 5.5918 21.1577H17.5916C18.8342 21.1577 19.8416 20.1504 19.8416 18.9077V10.8385C19.1992 11.1837 18.4645 11.3795 17.6841 11.3795C15.1629 11.3795 13.1191 9.33564 13.1191 6.81451ZM7.09375 13.6582C7.09375 13.244 7.42954 12.9082 7.84375 12.9082H11.5938C12.008 12.9082 12.3438 13.244 12.3438 13.6582C12.3438 14.0724 12.008 14.4082 11.5938 14.4082H7.84375C7.42954 14.4082 7.09375 14.0724 7.09375 13.6582ZM7.84375 15.9082H15.3438C15.758 15.9082 16.0938 16.244 16.0938 16.6582C16.0938 17.0724 15.758 17.4082 15.3438 17.4082H7.84375C7.42954 17.4082 7.09375 17.0724 7.09375 16.6582C7.09375 16.244 7.42954 15.9082 7.84375 15.9082Z",
    fill: "currentColor "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoNotificationText);
export default __webpack_public_path__ + "static/media/DuoNotificationText.615e58a413eb7e4f14fe546f18a09007.svg";
export { ForwardRef as ReactComponent };